import { mmFetchWithResponse } from './mmFetchWithResponse';

class InventoryAdjustmentApi {
    constructor() {
        this.baseUrl = 'api/inventory-adjustment/v1';
    }

    async getHistoricalBulkShrinkRequests(facilityId, startDate, endDate) {
        const url = `${this.baseUrl}/bulkShrink/historical?facilityId=${facilityId}&startDate=${startDate}&endDate=${endDate}`;
        return mmFetchWithResponse(url);
    }

    async createBulkShrink(data) {
        const url = `${this.baseUrl}/bulkShrink/create`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async getPendingBulkShrinkRequests(facilityId) {
        const url = `${this.baseUrl}/bulkShrink/pending?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    }

    async updatePendingBulkShrinkRequest(id, key, value) {
        const url = `${this.baseUrl}/bulkShrink/update/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ [key]: value }),
        });
    }

    async approveBulkShrinkRequests(ids) {
        const idsParam = Array.isArray(ids) ? ids : [ids];
        const url = `${this.baseUrl}/bulkShrink/approve`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ ids: idsParam }),
        });
    }

    async rejectBulkShrinkRequests(ids) {
        const idsParam = Array.isArray(ids) ? ids : [ids];
        const url = `${this.baseUrl}/bulkShrink/reject`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ ids: idsParam }),
        });
    }

    async getItemsForFacilityWeekYear(facilityId, week, year) {
        const url = `${this.baseUrl}/bulkShrink/items/${facilityId}?week=${week}&year=${year}`;
        return mmFetchWithResponse(url);
    }

    async resolveUnitDiscrepancyWithMagnitudeAdjustment(cycleCountEventId, unitAdjustment, reason, palletId) {
        const url = `${this.baseUrl}/cycle-count/unit-discrepancy`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ cycleCountEventId, unitAdjustment, reason, palletId }),
        });
    }

    async getBulkShrinkItemsForShipment({ facilityId, shipmentID }) {
        const url = `${this.baseUrl}/bulkShrink/items/${facilityId}/shipment/${shipmentID}`;
        return mmFetchWithResponse(url);
    }

    async uploadShipmentIdBulk(file, { facilityId } = {}) {
        const url = `${this.baseUrl}/bulkShrink/shipment/upload`;
        const formData = new FormData();
        if (facilityId !== undefined && facilityId !== null) {
            formData.append('facilityId', String(facilityId));
        }
        formData.append('file', file);
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
        });
    }

    async fetchShipmentIdBulk(key, _params, signal) {
        const url = `${this.baseUrl}/bulkShrink/shipment/fetch?key=${encodeURIComponent(key)}`;
        return mmFetchWithResponse(url, { signal });
    }

    async editShipmentIdBulk(key, _params, rowsToUpdate, rowsToDelete) {
        const url = `${this.baseUrl}/bulkShrink/shipment/edit`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({
                key,
                rowsToUpdate,
                rowsToDelete,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async persistShipmentIdBulk(key) {
        const url = `${this.baseUrl}/bulkShrink/shipment/persist`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }
}

export { InventoryAdjustmentApi };
